export default __webpack_public_path__ + "media/images/logo_full-80f017e6f6e8e9f1cddda23ad7f17e70.svg";